<template>
  <div class="select-container">
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <div v-loading="loading" style="display: block">
      <el-select
        v-model="currentValue"
        :placeholder="fillPlaceHolder"
        :name="name"
        :multiple="multiple"
        :collapse-tags="collapseTags"
        :readonly="readonly"
        :disabled="disabled"
        :required="required"
        :clearable="!required && !multiple"
        :default-first-option="defaultFirstOption"
        :filterable="filterable"
        @input="handleModelInput"
      >
        <el-option
          v-for="item in options"
          :key="item[valueField]"
          :label="item[labelField]"
          :value="item[valueField]"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    collapseTags: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    labelField: {
      default: 'value',
      type: String
    },
    name: String,
    defaultFirstOption: {
      default: false,
      type: Boolean
    },
    placeholder: {
      default: '',
      type: String
    },
    multiple: {
      default: false,
      type: Boolean
    },
    value: [String, Number, Array],
    options: Array,
    readonly: {
      default: false,
      type: Boolean
    },
    required: {
      default: true,
      type: Boolean
    },
    valueField: {
      default: 'id',
      type: String
    },
    filterable: {
      default: true,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    selectFirstOnDefault: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    fillPlaceHolder() {
      return this.currentValue ? '' : this.placeholder;
    }
  },
  watch: {
    value(newValue) {
      if (newValue === '' && this.selectFirstOnDefault && this.options.length > 0) {
        this.handleModelInput(this.options[0][this.valueField]);
      } else {
        this.currentValue = newValue;
      }
    },
    options(options) {
      if (this.value === '' && this.selectFirstOnDefault && options.length > 0) {
        this.handleModelInput(options[0][this.valueField]);
      }
    }
  },
  methods: {
    handleModelInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>
<style scoped>
.material-label {
  color: #9e9e9e;
}
.el-select {
  width: 100%;
  max-width: 300px;
}
</style>
